<template>
    <div class="page__footer">
      <div class="container is-relative">
        <div class="page__footer__info columns is-multiline is-gapless-touch">
          <div class="item item--logo column is-3 is-12-touch pl-0-touch bd-0-touch">
            <img src="/icon-logo.png" :src="require('@/assets/img/icon-logo-footer.png')" alt="">
          </div>
          <div class="item item--addr column is-6 is-12-touch pl-0-touch bd-0-touch">
            <p>广东省广州市荔湾区黄沙大道15号御景壹号南岸至尚美术馆二楼</p>
            <p>电话：020-81535882</p>
            <p>邮箱：info@xuqinsong-art.org.cn</p>
          </div>
          <div class="is-hidden-mobile item is-relative item--share column is-3 is-12-touch pl-0-touch bd-0-touch">
            <div class="is-hoverable">
              <img :src="require('@/assets/img/icon-wechat.png')">
              <img class="show-in-hover is-absolate" :src="require('@/assets/img/img-xqs_wx_qrcode.jpg')">
            </div>
            <div class="is-hoverable">
              <img :src="require('@/assets/img/icon-weibo.png')">
              <img class="show-in-hover is-absolate" style="left: 120px;" :src="require('@/assets/img/img-xqs_weibo.png')">
            </div>
            <div class="is-hoverable">
              <img :src="require('@/assets/img/icon-bilibili.png')">
              <img class="show-in-hover is-absolate" style="left: 190px;" :src="require('@/assets/img/img-xqs_bilibili.png')">
            </div>
          </div>
        </div>
        <hr class="is-hidden-mobile">
        <div class="page__footer__links columns is-multiline">
          <span class="column is-4 is-12-touch has-text-left">版权所有 广东省许钦松艺术基金会<a href="http://beian.miit.gov.cn/" style="color: #383838;margin-left: 10px;display:inline">粤ICP备20017424号-1</a></span>
          <div class="page__footer__links__nav column is-8 is-12-touch is-flex is-flex-touch is-justify-content-flex-end is-hidden-mobile">
            <a class="is-inline-flex is-align-items-center " style="color: #6bbb8d" @click="toTop()">回到顶部<i style="width: 20px; height: 20px" class="ml-1" data-feather="chevron-up"></i></a>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
export default {
    name: 'header_html',
    data () {
        return {
        }
    },
    mounted: function () {
    },
    methods: {
        toTop(){
            document.documentElement.scrollTop = 0;
        },
    }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/footer_html.vue